module.exports = __webpack_public_path__ + "static/media/painted-ladies.2bf5bc55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/painted-ladies.jpg
// module id = 311
// module chunks = 0